import { Image } from '@rocco/components/image';
import { Link } from '@remix-run/react';
import { ReactComponent as ArrowRight } from '@rocco/icons/svg/arrow/arrow-right.svg';

interface CardSearchCategoryProps {
    category: {
        title: string;
        link: string;
        image: string;
        type: string;
    };
    onClick: () => void;
}

export const CardSearchCategory = ({
    category,
    onClick,
}: CardSearchCategoryProps) => {
    return (
        <Link
            to={category.link}
            onClick={onClick}
            className="relative flex h-[7.125rem] w-[17.875rem] cursor-pointer gap-2 rounded-2xl bg-[#f2f2f2] p-[12px] pr-5 hover:bg-brick-800"
        >
            <div className="relative shrink-0 inline-flex max-w-[5.625rem] w-1/3 h-auto items-center justify-start rounded-lg bg-white overflow-hidden">
                {category.image && (
                    <Image
                        src={category.image}
                        alt={category.title}
                        width={180}
                        height={180}
                        fill
                    />
                )}
            </div>
            <div className="inline-flex flex-col items-start justify-start gap-2 py-[5px] flex-1">
                <div className="shrink grow basis-0 self-stretch text-base font-medium leading-tight tracking-tight text-gray-900">
                    <span>{category.title}</span>
                </div>
                <div className="self-stretch text-xs font-medium uppercase leading-[10px] tracking-wide text-gray-900">
                    {category.type}
                </div>
                <div className="absolute bottom-[12px] right-[12px]">
                    <ArrowRight className="w-[18px]" />
                </div>
            </div>
        </Link>
    );
};
